module.exports = __webpack_public_path__ + "static/media/timer.6894d61b.svg";